import '@fortawesome/fontawesome-free/css/all.min.css'
import 'bootstrap-css-only/css/bootstrap.min.css'
import 'mdbvue/lib/css/mdb.min.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

const firebase = require("firebase");
// Required for side-effects
require("firebase/firestore");

Vue.config.productionTip = false

import Notify from 'mdbvue/lib/components/Notify'
Vue.use(Notify)

const firebaseConfig = {
  apiKey: "AIzaSyAhCmz2d-BAXeJqiPGooBeQYVagi2QkP-M",
  authDomain: "dblokewebsite.firebaseapp.com",
  databaseURL: "https://dblokewebsite.firebaseio.com",
  projectId: "dblokewebsite",
  storageBucket: "dblokewebsite.appspot.com",
  messagingSenderId: "810628288610",
  appId: "1:810628288610:web:90f1701391d663753f013b"
};

// Initialize Cloud Firestore through Firebase
firebase.initializeApp(firebaseConfig);

var db = firebase.firestore();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

export default db;